import {makeAutoObservable} from 'mobx'
import {DataObjectId} from 'yougile-model'

interface State {
  selectedProjectId?: DataObjectId
  selectedBoardId?: DataObjectId
}

export class ByTimeGlobalStore {
  state: State

  constructor() {
    this.state = {}

    makeAutoObservable(this, {}, {autoBind: true})
  }

  onSelectProject(id: DataObjectId): void {
    this.state.selectedProjectId = id
  }

  onSelectBoard(id: DataObjectId | undefined): void {
    this.state.selectedBoardId = id
  }
}

export const byTimeGlobalStore = new ByTimeGlobalStore()
